import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { getLabel } from '@/helpers/Utils';

export const fetchNotificationTypes = createAsyncThunk(
  'notificationType/fetchNotificationTypes',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetNotificationTypes();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: getLabel(item.nameAr, item.nameEn),
          value: item.id,
          type:item.type,
          typeName:item.typeName,
          parameters: item?.parameters?.map((parameter) => ({
            id: parameter.id,
            value: parameter.id,
            nameAr: parameter.nameAr,
            nameEn: parameter.nameEn,
            label: getLabel(parameter.nameAr, parameter.nameEn),
            parameterValue: parameter.parameterValue,
            notificationType: parameter.notificationType,
          })),
        })) ?? [];
      return mappedData;
    } catch (error) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  notificationTypesList: [],
  loading: false,
  error: '',
};

const notificationTypeSlice = createSlice({
  name: 'notificationType',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotificationTypes.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNotificationTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.notificationTypesList = action.payload;
        state.error = '';
      })
      .addCase(fetchNotificationTypes.rejected, (state, action) => {
        state.loading = false;
        state.notificationTypesList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default notificationTypeSlice.reducer;
